import Main from "./character/main";
const main = new Main();
